import { jsx as _jsx } from "react/jsx-runtime";
import generateIcon from './icon';
import ReactComponent from './component-brand/timeout';
export default generateIcon(_jsx(ReactComponent, {}, void 0));